const RUM_PREFIX = 'https://js-cdn.dynatrace.com/jstag/1624d0f62e6/bf01571vpf/'

const DEFAULT_RUM_URL: Record<string, string> = {
  development: `${RUM_PREFIX}cdf59c82937f2df7_complete.js`,
  production: `${RUM_PREFIX}bcbc62f67eabe9bf_complete.js`,
}

export function resolveDynatraceRumUrl(): string | undefined {
  const raw = import.meta.env.VITE_DYNATRACE_RUM_URL?.trim()
  if (!raw) return DEFAULT_RUM_URL[import.meta.env.MODE] ?? DEFAULT_RUM_URL.production
  const lower = raw.toLowerCase()
  if (lower === 'off' || lower === 'false' || lower === 'none' || lower === '0') return undefined
  return raw
}
